import { LeadStatusType } from '../components/common/StatusBadge/LeadStatusBadge';

export interface LeadListArgument {
  page?: number;
  size?: number;
  sort?: string;
  search?: string;
  countryId?: string;
  statusId?: string;
  clientId?: string;
  region?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  lastUpdatedDateFrom?: string;
  lastUpdatedDateTo?: string;
}

export interface LeadFilterParams {
  countryId?: string;
  status?: string[];
  clientId?: string;
  region?: string;
  lastUpdatedBy?: string;
  createdBy?: string;
  createdDate?: [Date, Date];
  lastUpdatedDate?: [Date, Date];
}

export const LeadStatusTypes = {
  MANUAL_REVIEW: { value: 'MANUAL_REVIEW', label: 'Manual Review' },
  PROCESSING: { value: 'PROCESSING', label: 'Processing' },
  PENDING_INFORMATION: { value: 'PENDING_INFORMATION', label: 'Pending Information' },
  CONVERTED: { value: 'CONVERTED', label: 'Converted' },
  REJECTED: { value: 'REJECTED', label: 'Rejected' },
};

// Define allowed status transitions
export const AllowedStatusTransitions: Record<LeadStatusType, LeadStatusType[]> = {
  MANUAL_REVIEW: ['PROCESSING', 'PENDING_INFORMATION', 'REJECTED', 'CONVERTED'],
  PROCESSING: ['PENDING_INFORMATION', 'REJECTED', 'CONVERTED'],
  PENDING_INFORMATION: ['PROCESSING', 'REJECTED', 'CONVERTED'],
  REJECTED: [],
  CONVERTED: [],
};

type AssignmentRolesKeys =
  | 'administrator'
  | 'salesManager'
  | 'salesManagerAssistant'
  | 'purchaseManager'
  | 'purchaseManagerAssistant'
  | 'postSalesManager'
  | 'postSalesManagerAssistant';
export const AssignmentRoleMapping: Record<AssignmentRolesKeys, string> = {
  administrator: 'Administrator',
  salesManager: 'Sales Manager',
  salesManagerAssistant: 'SM Assistant',
  purchaseManager: 'Purchase Manager',
  purchaseManagerAssistant: 'PM Assistant',
  postSalesManager: 'Post-Sales Manager',
  postSalesManagerAssistant: 'Post-SM Assistant',
};

export const RejectionReasons = {
  OUT_OF_SCOPE: { label: 'Out of scope', value: 'OUT_OF_SCOPE' },
  INSUFFICIENT_INFO: { label: 'Insufficient information', value: 'INSUFFICIENT_INFO' },
  DUPLICATE_LEAD: { label: 'Duplicate lead', value: 'DUPLICATE_LEAD' },
  CUSTOMER_NOT_RESPONSIVE: { label: 'Customer not responsive', value: 'CUSTOMER_NOT_RESPONSIVE' },
  NO_LONGER_NEEDED: { label: 'No longer needed', value: 'NO_LONGER_NEEDED' },
  OTHER: { label: 'Other', value: 'OTHER' },
};

type Lead = {
  id: string;
  uuid: string | number;
  client: Record<string, any>; //Client Object
  country: {
    id: string;
    name: string;
    fileLocation?: string;
  };
  region: string;
  status: string;
  createdDate: string;
  lastModifiedDate: string;
  clientRequestNum: string;
  formattedCreatedDate?: {
    full: string;
    day: string;
  };
  formattedLastModifiedDate?: {
    full: string;
    day: string;
  };
};

export type { Lead, AssignmentRolesKeys };
